import { useQuery } from "@tanstack/react-query";

import ActivityService from "services/Activity";

const fetchCategories = async () => {
  const rawCategories = await ActivityService.getCategories();
  const newCategories = rawCategories.map(category => ({
    key: category.id,
    text: category.name,
    value: category.id,
    name: category.name,
    hidden: category.is_hidden,
  }));

  return newCategories;
};

export function useActivityCategories() {
  const { data: categories, refetch: refetchCategories } = useQuery({
    initialData: [],
    queryKey: ["activity-categories"],
    queryFn: fetchCategories,
  });

  return {
    categories,
    refetchCategories,
  };
}
